import { getAwsAssets } from "@src/utils";
import Image from "@src/lib/Image";
import { useState, useRef, useEffect } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import {
  idfyPrepurchageModalCloseAction,
  idfyPrepurchageOtpVerifyAction,
  idfyPrepurchaseOtpGenerateAction,
} from "../../../../Content/store/actions";
import { idfysContentLockAction } from "@src/components/BottomSheets/store/actions";
import { initialisePaymentService } from "@src/PaymentService";

function PrepurchageIdfys({
  handlePaymentSucess = () => {},
  setIsIdfyEmailVerificationEnabled = () => {},
  emailVerifyAction = () => {},
}) {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [timer, setTimer] = useState(30);
  const inputsRef = useRef([]);

  const dispatch = useDispatch();
  const metaData = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.metaData
  );
  const userEmail = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.metaData?.verificationDetails?.prePurchase?.verificationId
  );
  const prepurchage = useSelector(
    (state) => state?.courseContentReducer?.idfyPrepurchage
  );

  useEffect(()=>{
    if(userEmail) {
      setEmail(userEmail)
    }
  },[userEmail])

  const isLockedContentClick = useSelector((state) => state?.bottomSheetReducer?.isIdfysLockContentClicked);

   const orgCode = useSelector((state) => state?.persistedDataReducer?.orgDetails?.organization?.code);
  const callbackVerifyOtp = () => {
    emailVerifyAction();
    if(isLockedContentClick) {
      initialisePaymentService();
      dispatch(idfysContentLockAction(false));
      handleCloseModal();
    } else {
       setIsIdfyEmailVerificationEnabled(false);
       handlePaymentSucess();
    }
  };

  const handleVerifyOtp = () => {
    const otpVerifyPayload = {
      sessionId: prepurchage?.sessionId || null,
      orgId: metaData?.orgId || null,
      courseId: metaData?.id || null,
      email: email,
      otp: otp.join(""),
      verifyFor: "stu_ver",
    };
    dispatch(
      idfyPrepurchageOtpVerifyAction({
        payload: otpVerifyPayload,
        callback: callbackVerifyOtp,
      })
    );
  };
  
  const handleCloseModal = () => {
    dispatch(idfyPrepurchageModalCloseAction());
    setIsIdfyEmailVerificationEnabled(false);
    dispatch(idfysContentLockAction(false));
  };

  const content = {
    header: {
      title: prepurchage?.isOtpGenerated
        ? "Verify OTP"
        : "Please confirm your details",
      close: () => handleCloseModal(),
      icon: getAwsAssets(`crossIcon.svg`, "bottomSheets"),
    },
    footer: {
      btn: prepurchage?.isOtpGenerated ? "Verify via OTP" : "Verify",
      onClick: prepurchage?.isOtpGenerated
        ? () => handleVerifyOtp()
        : () => callbackFooterButton(),
      disabled: prepurchage?.isOtpGenerated
        ? !isValidOTP()
        : !isValidEmail(email),
    },
  };

  useEffect(() => {
    if (prepurchage?.isOtpGenerated) {
      const timeout = setTimeout(() => {
        requestAnimationFrame(() => {
          if (inputsRef.current[0]) {
            inputsRef.current[0].focus();
          }
        });
      }, 50);
      return () => clearTimeout(timeout);
    }
  }, [prepurchage?.isOtpGenerated]);

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (/^\d?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (value && index < 3 && inputsRef.current[index + 1]) {
        inputsRef.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    const key = e.key;
    if (key === "Backspace") {
      if (!otp[index] && index > 0 && inputsRef.current[index - 1]) {
        inputsRef.current[index - 1].focus();
      }
    } else if (
      key === "ArrowLeft" &&
      index > 0 &&
      inputsRef.current[index - 1]
    ) {
      inputsRef.current[index - 1].focus();
    } else if (
      key === "ArrowRight" &&
      index < 3 &&
      inputsRef.current[index + 1]
    ) {
      inputsRef.current[index + 1].focus();
    } else if (key === "Enter") {
      if (!otp[index] && index > 0 && inputsRef.current[index - 1]) {
        inputsRef.current[index - 1].focus();
      }
    }
  };

  const handleResend = () => {
    setOtp(["", "", "", ""]);
    setTimer(30);
    if (inputsRef.current[0]) {
      inputsRef.current[0].focus();
    }
    const payload = {
      orgCode: orgCode,
      viaSms: "0",
      viaEmail: "1",
      retry: 0,
      orgId: metaData?.orgId,
      otpCount: 4,
      email: email,
      requestFor: "stu_ver",
    };
    dispatch(
      idfyPrepurchaseOtpGenerateAction({
        payload: payload,
        callback : otpGenerateCallback,
        isResend: true,
      })
    );
  };

  function isValidEmail(email) {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  }

  const generateUniqueIntegerId = () => {
    const timestamp = Date.now(); // milliseconds since epoch
    const random = Math.floor(Math.random() * 10000); // 0 - 9999
    return Number(`${timestamp}${random.toString().padStart(4, "0")}`);
  };

  const otpGenerateCallback = () => {
    setTimer(30);
  }
  const callbackFooterButton = () => {
    const isEmailValid = isValidEmail(email);
    if (!isEmailValid) {
      toast.error("Please enter valid email");
      return;
    }

    const payload = {
      orgCode: orgCode,
      viaSms: "0",
      viaEmail: "1",
      retry: 0,
      orgId: metaData?.orgId,
      otpCount: 0,
      email: email,
      requestFor: "stu_ver",
    };
    dispatch(
      idfyPrepurchaseOtpGenerateAction({ payload: payload, isResend: false,callback : otpGenerateCallback })
    );
  };

  function isValidOTP() {
    return otp.every((digit) => digit !== "");
  }

  console.log("animesh0000", metaData);

  return (
    <div className="idfy-prepurchage">
      <div className="container">
        <div className="header">
          <p className="tittle">{content["header"].title}</p>
          <Image
            className="close-icon"
            src={content["header"].icon}
            alt="shareIcon"
            height={24}
            width={24}
            onClick={content["header"].close}
          />
        </div>
        <p className="divider"></p>
        {prepurchage?.isOtpGenerated ? (
          // -----------Otp Generated ------------

          <div className="otp-container ">
            <p className="bodyTittle">We’ve sent an OTP to your email id </p>
            <input
              className="emailVerificationInput"
              type="text"
              readOnly={true}
              value={email}
            />

            <div className="otpContainer">
              <p className="otpTitle">Enter OTP here</p>
              <div className="otpInputs">
                {otp.map((digit, idx) => (
                  <input
                    key={idx}
                    type="tel"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    maxLength={1}
                    value={digit}
                    ref={(el) => (inputsRef.current[idx] = el)}
                    onChange={(e) => handleChange(e, idx)}
                    className="otpInput"
                    onKeyDown={(e) => handleKeyDown(e, idx)}
                  />
                ))}
              </div>
              <div className="otpTimer">
                {timer > 0 ? (
                  <p>
                    Waiting for OTP <span>{timer}s</span>
                  </p>
                ) : (
                  <button onClick={handleResend} className="otpResend">
                    Resend OTP
                  </button>
                )}
                <p className="verificationFooterText">
                  Your OTP verification signifies your consent to the guidelines that have been sent to the provided email address.
                </p>
              </div>
            </div>
          </div>
        ) : (
          // -------------------------------------------
          <div className="inputContainer">
            <label htmlFor="student-otp">Email Address</label>
            <input
              type="text"
              placeholder="name@gmail.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
        )}

        <div className="footer">
          <button
            disabled={content["footer"].disabled || false}
            onClick={content["footer"].onClick}
            className="btn"
          >
            {content["footer"].btn}
          </button>
        </div>
      </div>
    </div>
  );
}

export default PrepurchageIdfys;
